export function pgMonitorPresentation(result, error, busy) {
  const count = result?.unresolved?.count;
  const validCount = count != null && /^\d+$/.test(String(count));
  const hasIncidents = validCount && /[1-9]/.test(String(count));
  const noIncidents = validCount && !hasIncidents;
  const status = result?.checkStatus;
  const unresolved = hasIncidents || status === 'WARNING';
  const reviewReasons = result?.comparison?.reviewReasons;
  const noBaseline = Array.isArray(reviewReasons) && reviewReasons.includes('NO_PRE_DEPOSIT_BASELINE');
  const warningClass = 'border-amber-300 bg-amber-50 text-amber-950';
  const infoClass = 'border-blue-200 bg-blue-50 text-slate-800';
  const neutralClass = 'border-slate-200 bg-slate-50 text-slate-700';
  if (unresolved) return {
    title: hasIncidents ? `미해소 경고 ${count}건` : '미해소 경고 있음',
    description: error ? '최신 검사 결과 확인 불가 · 이전 경고를 유지하고 있습니다.' : '현재 차액과 관계없이 미해소 사건을 확인해 주세요.',
    className: warningClass, warning: true,
  };
  if (error) return { title: '최신 검사 결과 확인 불가', description: '이전 조회 결과는 최신 상태가 아닙니다. 다시 확인해 주세요.', className: warningClass, warning: true };
  if (status === 'REVIEW_REQUIRED') return {
    title: noBaseline ? '현재 금액 검증 불가' : '현재 검사 확인 필요',
    description: `${noIncidents ? '미해소 사건은 없습니다. ' : ''}${noBaseline ? '입금 전 기준 잔액이 없어 오늘 정산금은 검증할 수 없습니다.' : '관측 금액 또는 검사 근거 확인이 필요합니다.'}`,
    className: noBaseline ? infoClass : warningClass,
    warning: !noBaseline,
  };
  if (status === 'WAITING') return { title: '입금 대기', description: '입금 대기 상태입니다. 정상 입금 확정을 의미하지 않습니다.', className: neutralClass, warning: false };
  if (status === 'WITHIN_TOLERANCE_ESTIMATE') return { title: '허용오차 내 추정', description: '추정 비교 결과이며 지급·출금 가능 여부를 보장하지 않습니다.', className: infoClass, warning: false };
  return { title: status === 'DISABLED' ? '기능 비활성' : busy ? '설정 확인 중' : '확인 필요', description: '갤럭시아 계정 전체 기준 · 선택한 CP/기간과 무관', className: neutralClass, warning: false };
}
